//TODO standard: second version with holder
//TODO standard: handle after init/change
//TODO multiple
//TODO custom: on focus handle keydown events
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD
        define(['jquery','lodash'], factory);
    } else if (typeof exports === 'object') {
        // Node, CommonJS-like
        module.exports = factory(require('jquery'), require('lodash'));
    } else {
        // Browser globals (root is window)
        root.s3l3ct = factory(root.jQuery, root._);
    }
})(this, function ($,_) {

    'use strict';

    var VERSION = "2.0", defaults = {}, $document = $(document);

    var KEYS = {
        TAB: 9,
        ENTER : 13,
        ESC : 27,
        SPACE: 32,
        UP: 37,
        LEFT: 38,
        DOWN: 39,
        RIGHT: 40
    };

    defaults = {
        afterInit:undefined,
        afterChange:undefined,
        searchable: false,
        multiple_limit: -1
    };

    var build_standard = function($el,opts) {

        if($el.parent('.j-s3l3ct-container').length===0){
            var settings = $.extend({},defaults,opts);

            var on_focus_select = function(evt){
                var $curr = $(this);
                var is_focus = evt.type==='focus';
                var $wrapper = $curr.closest('.j-s3l3ct-standard-container');
                $wrapper.toggleClass('has-focus',is_focus);
            };

            var $wrapper = $("<div/>",{class: $el.attr('class') + " standard j-s3l3ct-standard-container"});
            $el.wrap($wrapper).on('focus blur',on_focus_select);
        }
    };

    var build_custom = function($el,opts) {

        if($el.parent('.j-s3l3ct-custom-container').length===0){
            var settings,$wrapper,$label,$ul,$options,$items,is_multiple;
            settings = $.extend({},defaults,opts);
            is_multiple = $el.is("[multiple]");

            var init = function() {
                build_structure();
                set_events();
                apply_callback(settings.afterInit);
            };

            var build_structure = function() {
                $wrapper = $("<div/>",{class: $el.attr('class') + " j-s3l3ct-custom-container"});
                $label = $("<label/>",{for: $el.attr('id')});
                $ul = $("<ul/>");
                $options = $el.find('option');

                create_list();

                $el
                    .wrap($wrapper)
                    .after($ul)
                    .after($label)
                    .end();
            };

            var create_list = function(){
                $.each($options,function(index,item){
                    var $item = $(item);
                    var is_selected = ($.inArray($item.val(),$el.val()) > -1) || $item.val()===$el.val();
                    var $li = $('<li/>',{class:(is_selected?' selected ':''),text:$item.text(),'data-value':$item.val(),'data-option-index':index});

                    //set extra attributes
                    var jsAttrs = $item.get(0).attributes;
                    _.each(jsAttrs,function(item){
                        if(_.startsWith(item.name, 'data-')){
                            $li.get(0).setAttribute(item.name,item.value);
                        }
                    });

                    if(is_selected){
                        update_value($li);
                    }

                    //append li to ul
                    $ul.append($li);
                });
            };

            var update_value = function($item) {
                if(is_multiple) {
                    var is_add = $item.hasClass('selected');
                    var values = $el.val();
                    if (is_add) {
                        values.push($item.data('value'));
                    } else {
                        _.pullAt(values,_.indexOf(values,$item.data('value')));
                    }
                    $el.val(values);
                } else {
                    $label.text($item.text()).attr('title',$item.text());
                    $el.val($item.data('value')).change();
                }
            };

            var set_events = function() {
                $items = $ul.find('li');

                $ul.off('toggle.s3l3ct').on('toggle.s3l3ct',toggle_ul)
                    .off('close.s3l3ct').on('close.s3l3ct',close_ul);
                $label.off('click.s3l3ct').on('click.s3l3ct',toggle_select);
                $items
                    .off('click.s3l3ct').on('click.s3l3ct',toggle_item)
                    .off('mouseenter.s3l3ct mouseleave.s3l3ct').on('mouseenter.s3l3ct mouseleave.s3l3ct',hover_item);

                set_document_events();
            };

            var set_document_events = function() {

                var $custom_containers = $('.j-s3l3ct-custom-container');

                var document_click_handler = function(evt) {
                    if(!$(evt.target).is(".j-s3l3ct-custom-container, .j-s3l3ct-custom-container * ")){
                        $(".j-s3l3ct-custom-container ul").trigger('close.s3l3ct');
                    }
                };

                var document_keydown_handler = function(evt) {
                    var key_code,$item_selected,index,new_index,last_index,$opened_ul,$select_active,select_has_focus,go_to_item;
                    key_code = evt.keyCode || evt.which;
                    $opened_ul = $custom_containers.find('ul.open');
                    $select_active = $custom_containers.find('select').filter(':focus');
                    select_has_focus = $select_active.length > 0;

                    go_to_item = function(index) {
                        $item_selected = $opened_ul.find('li:eq('+(index)+')');
                        scroll_to_item($opened_ul,$item_selected);
                        $item_selected.trigger('mouseenter');
                    };

                    if($opened_ul.length===0) {
                        if(!select_has_focus || KEYS.TAB === key_code) {
                            return;
                        }
                        evt.preventDefault();
                        if(_.includes([KEYS.ENTER,KEYS.SPACE,KEYS.DOWN,KEYS.RIGHT],key_code)) {
                            $select_active.next('label').trigger('click.s3l3ct');
                        }
                        return;
                    }

                    evt.preventDefault();
                    $item_selected = $opened_ul.find('li.active');
                    index = $item_selected.length===0?0:$item_selected.index();
                    last_index = $opened_ul.find('li').length - 1;

                    switch (key_code) {
                        case KEYS.ESC:
                            $document.trigger('click.s3l3ct');
                            break;
                        case KEYS.ENTER:
                        case KEYS.SPACE:
                            $item_selected.trigger('click.s3l3ct');
                            break;
                        case KEYS.UP:
                        case KEYS.LEFT:
                            new_index = (index-1)<0?last_index:index-1;
                            go_to_item(new_index);
                            break;
                        case KEYS.DOWN:
                        case KEYS.RIGHT:
                            new_index = (index+1)>last_index?0:index+1;
                            go_to_item(new_index);
                            break;
                    }

                };

                $document.off('click.s3l3ct').on('click.s3l3ct',document_click_handler);
                $document.off('keydown.s3l3ct').on('keydown.s3l3ct',document_keydown_handler);
            };

            var toggle_ul = function(evt) {
                $label.toggleClass('open');
                $ul.toggleClass('open');
            };

            var close_ul = function() {
                $label.removeClass('open');
                $ul.removeClass('open');
            };

            var toggle_select = function(evt) {
                evt.preventDefault();
                var $uls = $(".j-s3l3ct-custom-container ul");
                $uls.not($ul).trigger('close.s3l3ct');
                $ul.trigger('toggle.s3l3ct');
                var $item_selected = $items.filter('.selected');
                scroll_to_item($ul,$item_selected);
                $item_selected.trigger('mouseenter');
            };

            var toggle_item = function(evt) {
                var $curr = $(this);

                if(is_multiple) {

                } else {
                    $items.removeClass('selected');
                    $curr.addClass('selected');
                    update_value($curr);
                    $ul.trigger('close.s3l3ct');
                }

                apply_callback(settings.afterChange);

            };

            var hover_item = function(evt) {
                var is_hover = ('mouseenter'===evt.type);
                $(this).toggleClass('active',is_hover).siblings().removeClass('active');
            };

            var scroll_to_item = function($container,$item) {
                var maxHeight = parseInt($container.css("maxHeight"), 10);
                var visible_top = $container.scrollTop();
                var visible_bottom = maxHeight + visible_top;
                var high_top = $item.position().top + $container.scrollTop();
                var high_bottom = high_top + $item.outerHeight();
                var delta;
                if (high_bottom >= visible_bottom) {
                    delta = (high_bottom - maxHeight) > 0 ? high_bottom - maxHeight : 0;
                } else if (high_top < visible_top) {
                    delta = high_top;
                }
                //$container.scrollTop(delta);
                $container.animate({scrollTop:delta},100);
            };

            var apply_callback = function(callback,ctx) {
                if (typeof callback === "function") {
                    callback.apply(ctx,[$el,$ul,$label]);
                }
            };

            //let's rock
            init();
        }

    };

    var is_mobile_browser = (function() {
        // Adapted from http://www.detectmobilebrowsers.com
        var ua = navigator.userAgent || navigator.vendor || window.opera;
        // Checks for iOs, Android, Blackberry, Opera Mini, and Windows mobile devices
        return /iP(hone|od|ad)|Silk|Android|BlackBerry|Opera Mini|IEMobile/i.test(ua);
    })();

    var build = function(selector,opts,is_standard,force_custom) {
        var $selects = $(selector);
        if ($selects.length>0 && !$('body').hasClass('no-js')) {
            _.each($selects,function(item) {
                if(is_standard || (is_mobile_browser && !force_custom)) {
                    build_standard($(item),opts);
                } else {
                    build_custom($(item),opts);
                }
            });
        }
    };

    var standard = function(selector,opts) {
        build(selector,opts,true);
    };

    var standard_all = function(opts) {
        build('.j-s3l3ct-default',opts,true);
    };

    var custom = function(selector,opts) {
        build(selector,opts,false,true);
    };

    var custom_all = function(opts) {
        build('.j-s3l3ct-custom',opts,false,true);
    };

    var responsive = function(selector,opts) {
        build(selector,opts,false);
    };

    var responsive_all = function(opts) {
        build('.j-s3l3ct-custom',opts,false);
    };

    return {
        VERSION:VERSION,
        standard:standard,
        standard_all:standard_all,
        custom:custom,
        custom_all:custom_all,
        responsive:responsive,
        responsive_all:responsive_all
    };

});